import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
	@Input() requesting;

	@Output() formEmitter: EventEmitter<any> = new EventEmitter<any>();

	resetPasswordForm: FormGroup;

	passwordError = false;
	confirmPasswordError = false;
	mismatchPasswords = false;

	submitted = false;

	showPasswordArgs = [false, false];

	destroyed: ReplaySubject<boolean> = new ReplaySubject(1);

	constructor(private formBuilder: FormBuilder) {
		this.resetPasswordForm = this.createForm();
	}

	ngOnInit() {
		this.resetPasswordForm.valueChanges
			.pipe(takeUntil(this.destroyed))
			.subscribe(() =>
				this.submitted ? this.clearErrors() : (this.submitted = false)
			);
	}

	ngOnDestroy() {
		this.destroyed.next(true);
		this.destroyed.complete();
	}

	get passwordInvalid() {
		const control = this.resetPasswordForm.get('password');

		return !!control.errors;
	}

	get confirmPasswordInvalid() {
		const control = this.resetPasswordForm.get('confirmPassword');

		return !!control.errors;
	}

	get passwordMismatch() {
		if (
			this.resetPasswordForm.controls.password.value !==
			this.resetPasswordForm.controls.confirmPassword.value
		) {
			return true;
		}

		return false;
	}

	emitForm() {
		if (this.resetPasswordForm.valid && !this.passwordMismatch) {
			this.formEmitter.emit(this.resetPasswordForm.value);
			this.resetPasswordForm.reset();
		} else {
			if (this.passwordInvalid) {
				this.passwordError = true;
			}

			if (this.confirmPasswordInvalid) {
				this.confirmPasswordError = true;
			}

			if (this.passwordMismatch) {
				this.mismatchPasswords = true;
			}
		}

		this.submitted = true;
	}

	clearErrors() {
		this.passwordError = false;
		this.confirmPasswordError = false;
		this.mismatchPasswords = false;
	}

	createForm() {
		return this.formBuilder.group({
			password: ['', [Validators.required, Validators.minLength(6)]],
			confirmPassword: ['', [Validators.required, Validators.minLength(6)]]
		});
	}

	showPassword(index) {
		this.showPasswordArgs[index] = !this.showPasswordArgs[index];
	}
}
